import React from "react";

function SvgIcMapPoi004(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8 9.006c0-.555.448-1.004 1-1.004h7c.552 0 1 .449 1 1.004v5.993c0 .555-.448 1.003-1 1.003H9c-.552 0-1-.448-1-1.003V9.006zM16 6c1.525 0 3 1.5 3 3.004v7.127c0 1.53-1.035 2.557-1.986 3.045l-.011 5.1c.594.348.997.986.997 1.724H7c0-.745.41-1.388 1.014-1.732l-.005-5.13c-1.01-.475-2.01-1.59-2.01-3.007V9.004C6 7.5 7.524 6 9 6zm12.045 1.86l-.006 2L25 11.5 25 13.85a2 2 0 01-2 2v1.007l-.004.253c-.091 3.193-1.845 5.74-3.996 5.74v-2c1.105 0 2-1.791 2-4V12.85l.007-.17a1.997 1.997 0 011-1.556v-.016l6.038-3.247z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi004;
